module.exports = __webpack_public_path__ + "img/Q01a.42677912.png";